<template>
  <el-dialog
    title="预约结束"
    :visible.sync="timeDownDialogVisible"
    :show-close="false"
    width="400px"
    center
    :close-on-press-escape="false"
    :close-on-click-modal="false"
  >
    <div class="content">
      <p>您的预约已结束，系统将返回至账号首页</p>
      <p/>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onOk">确 定</el-button>
    </span>
  </el-dialog>
</template>

<style lang="scss" scoped>
.content {
  margin: 0 50px;
}
</style>

<script>
export default {
  data() {
    return {};
  },
  props: {
    timeDownDialogVisible: false
  },
  updated() {},
  created() {},
  methods: {
    onOk() {
      this.$emit("onOk");
    }
  },
  mounted() {}
};
</script>



// WEBPACK FOOTER //
// src/components/timeDownDialog.vue